/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleIntegrationUsagePeriodData
 */
export interface GoogleIntegrationUsagePeriodData {
    /**
     * 
     * @type {number}
     * @memberof GoogleIntegrationUsagePeriodData
     */
    requestCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleIntegrationUsagePeriodData
     */
    rowsPublished?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleIntegrationUsagePeriodData
     */
    bytesProcessed?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleIntegrationUsagePeriodData
     */
    durationMilliseconds?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleIntegrationUsagePeriodData
     */
    successfulFetches?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleIntegrationUsagePeriodData
     */
    failedFetches?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleIntegrationUsagePeriodData
     */
    skippedFetches?: number;
}

/**
 * Check if a given object implements the GoogleIntegrationUsagePeriodData interface.
 */
export function instanceOfGoogleIntegrationUsagePeriodData(value: object): value is GoogleIntegrationUsagePeriodData {
    return true;
}

export function GoogleIntegrationUsagePeriodDataFromJSON(json: any): GoogleIntegrationUsagePeriodData {
    return GoogleIntegrationUsagePeriodDataFromJSONTyped(json, false);
}

export function GoogleIntegrationUsagePeriodDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleIntegrationUsagePeriodData {
    if (json == null) {
        return json;
    }
    return {
        
        'requestCount': json['requestCount'] == null ? undefined : json['requestCount'],
        'rowsPublished': json['rowsPublished'] == null ? undefined : json['rowsPublished'],
        'bytesProcessed': json['bytesProcessed'] == null ? undefined : json['bytesProcessed'],
        'durationMilliseconds': json['durationMilliseconds'] == null ? undefined : json['durationMilliseconds'],
        'successfulFetches': json['successfulFetches'] == null ? undefined : json['successfulFetches'],
        'failedFetches': json['failedFetches'] == null ? undefined : json['failedFetches'],
        'skippedFetches': json['skippedFetches'] == null ? undefined : json['skippedFetches'],
    };
}

export function GoogleIntegrationUsagePeriodDataToJSON(json: any): GoogleIntegrationUsagePeriodData {
    return GoogleIntegrationUsagePeriodDataToJSONTyped(json, false);
}

export function GoogleIntegrationUsagePeriodDataToJSONTyped(value?: GoogleIntegrationUsagePeriodData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestCount': value['requestCount'],
        'rowsPublished': value['rowsPublished'],
        'bytesProcessed': value['bytesProcessed'],
        'durationMilliseconds': value['durationMilliseconds'],
        'successfulFetches': value['successfulFetches'],
        'failedFetches': value['failedFetches'],
        'skippedFetches': value['skippedFetches'],
    };
}

